import { Theme, alpha } from "@mui/material/styles";

export const HeaderDivider = {
    mb: 4,
    width: "100%",
    opacity: 0.7,
};

export const GradientHeaderText = (theme: Theme, active = false) => ({
    fontWeight: 600,
    background: active
        ? `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.primary.dark})`
        : `linear-gradient(45deg, ${theme.palette.text.primary}, ${alpha(theme.palette.text.primary, 0.8)})`,
    backgroundClip: "text",
    textFillColor: "transparent",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontSize: "1rem",
    color: theme.palette.text.primary,
});

export const HeaderBoxStyle = (theme: Theme) => ({
    position: "relative",
    zIndex: 1100,
    boxShadow: theme.shadows[2],
    backgroundColor: theme.palette.background.paper,
    borderBottom: "none",
    transition: `background-color 250ms cubic-bezier(0.2, 0, 0, 1.0)`,
    padding: "0px",
});

/**
 * Swaps the Fusion header's built-in GM logo for the MCC logo in-place.
 * Compose alongside {@link HeaderBoxStyle} on any Box wrapping an FsnHeader so
 * every header (root, restricted layouts, etc.) shows a consistent MCC logo.
 */
export const HeaderLogoSwap = {
    "& .fsn-header-logo-container svg": {
        display: "none",
    },
    "& .fsn-header-logo-container a": {
        display: "inline-block",
        width: "35px",
        height: "35px",
        backgroundImage: "url('/mcc-logo.png')",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
    },
};